// ABOUTME: Redux slice for tracking active background actions (shipping progress, exports, etc.)
// ABOUTME: Actions are displayed in the ProgressCenter component in the Topbar.

import { createSlice } from '@reduxjs/toolkit';
import { PURGE } from 'redux-persist';

const initialState = {
    actions: {},
    popoverOpen: false,
    // Maps entityId -> timestamp for individual product batches that finished processing,
    // so the echeck view can reset itself once its own batch completes.
    completedIndProdBatches: {},
};

const actionProgressSlice = createSlice({
    name: 'actionProgress',
    initialState,
    reducers: {
        addAction: (state, action) => {
            const { type, entityType, entityId,entity } = action.payload;
            const id = `${type}_${entityType}_${entityId}`;
            if (state.actions[id]) {
                return;
            }
            state.actions[id] = {
                id,
                type,
                entityType,
                entity,
                entityId,
                createdAt: Date.now(),
            };
            state.popoverOpen = true;
        },
        removeAction: (state, action) => {
            const id = action.payload;
            delete state.actions[id];
            if (Object.keys(state.actions).length === 0) {
                state.popoverOpen = false;
            }
        },
        setPopoverOpen: (state, action) => {
            state.popoverOpen = action.payload;
        },
        setIndProdBatchCompleted: (state, action) => {
            state.completedIndProdBatches[action.payload] = Date.now();
        },
        clearIndProdBatchCompleted: (state, action) => {
            delete state.completedIndProdBatches[action.payload];
        },
    },
    extraReducers: (builder) => {
        builder.addCase(PURGE, () => {
            return initialState;
        });
    },
});

export const { addAction, removeAction, setPopoverOpen, setIndProdBatchCompleted, clearIndProdBatchCompleted } = actionProgressSlice.actions;

export const selectActions = (state) => state.actionProgress.actions;
export const selectPopoverOpen = (state) => state.actionProgress.popoverOpen;
export const selectHasActions = (state) => Object.keys(state.actionProgress.actions).length > 0;
export const selectCompletedIndProdBatches = (state) => state.actionProgress.completedIndProdBatches;

export default actionProgressSlice;
